import React from 'react'

import styles from "../css/EweoucherLanding.module.css";
import { useTranslation } from 'react-i18next';

const EweoucherLanding = () => {
    const { t } = useTranslation('eweoucherLanding');

    return (<>
        <div className={`${styles['custom-container-fluid']} ${styles['main-container']}`}>
            <div className={`${styles['hero-section']}`}>
                <div className={`${styles['hero-section-image']}`}>
                    <img src="https://resource.ewe.rs/media/EWEoucher/HERO.png" alt="EWEoucher" className="img-fluid" />
                    <p className={styles['hero-image-tagline']}>{t('digitalniVaucer')}</p>
                </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className={`${styles['hero-section-title']}`}>
                                {t('nacin')}
                            </div>
                            <div className={`${styles['break-line']}`}>

                            </div>
                            <div className={`${styles['hero-section-text']}`}>
                                {t('dokazJe')} <span>{t('novaPog')}</span> {t('proizvoda')}
                                <span> {t('uskoro')}</span> {t('vasOcekuje')}<span>{t('ewe')}{t('oucherHero')}</span>{t('namenjen')} <span>{t('partnerima')}</span>{t('bezObzira')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                <div className={styles['sub-hero-section']}>
                    <div className="text-center">
                        <div className={styles['placeholder-ticket-centered']}>
                            <h3 className={styles['sub-hero-mobile-title']}>{t('staJe')}<span>{t('ewe')}{t('oucher')}</span>?</h3>
                            <picture className={styles['sub-hero-desktop-image']}>
                                <img src="https://resource.ewe.rs/media/EWEoucher/STA%20JE%20EWEOUCHER.png" alt="Šta je EWEoucher" className="img-fluid" />
                            </picture>
                            <p className={styles['content-body-block']}>{t('uskoro')} {t('medjuArtiklima')}{t('ewe')}{t('elektrVaucer')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`container`}>
                <div className={`${styles['second-section']}`}>
                    <div className={`${styles['second-section-column']} ${styles['qa-text']}`}>
                        <h3 className={styles['second-section-title']}>
                            {t('kojiArtikli')}<br></br>
                            {t('oznaku')}<span>{t('ewe')}{t('oucher')}</span>?
                        </h3>
                        <p className={styles['second-section-text']}>
                            {t('eArtikli')} {t('vaucerSaPopustom')}{t('periodPromocije')}{t('ewe')}{t('rasponArt')}
                        </p>
                        <h3 className={styles['second-section-title']} style={{ marginTop: "50px" }}>
                            {t('zaKojeArt')}<br></br>
                            {t('ceVaziti')}<span>{t('ewe')}{t('oucher')}</span>?
                        </h3>
                        <p className={styles['second-section-text']}>
                            {t('artikleZaCijuKupovinu')}{t('ewe')}{t('period')} {t('zeljeneArt')}.
                        </p>
                        <h3 className={styles['second-section-title']} style={{ marginTop: "40px" }}>{t('popust')}<span>{t('ewe')}{t('oucher')}</span>?</h3>
                        <p className={styles['second-section-text']}>
                            {t('iznosPopusta')}{t('ewe')}{t('dinarskojProtivVr')}
                        </p>
                        <h3 className={styles['second-section-title']} style={{ marginTop: "40px" }}>
                            {t('vazenjePopusta')}<br></br>
                            {t('dobijen')}<span>{t('ewe')}{t('oucher')}</span>{t('omSufiks')}
                        </h3>
                        <p className={styles['second-section-text']}>
                            {t('popustiDobijeni')}{t('ewe')}{t('istekom')}
                        </p>
                        <h3 className={styles['second-section-title']} style={{ marginTop: "40px" }}>
                            {t('kakoSeKoristi')}<span>{t('ewe')}{t('oucher?')}</span>?
                        </h3>
                        <p className={styles['second-section-text']}>
                            {t('nakonKupovine')}{t('ewe')}{t('primiceteEmail')}
                        </p>
                    </div>
                    <div className={`${styles['second-section-column']} ${styles['cart-image-column']}`}>
                        <picture>
                            <source media="(max-width: 1100px)" srcSet="https://resource.ewe.rs/media/EWEoucher/KOLICA-mob.png" />
                            <img src="https://resource.ewe.rs/media/EWEoucher/KOLICA.png" alt="EWEoucher" className="img-fluid" />
                        </picture>
                    </div>
                </div>
            </div>
            <div className={`${styles['custom-container-fluid-gradient']}`}>
                <div className={styles['footer-card-wrapper']}>
                    <div className={styles['footer-card-image-wrap']}>
                        <picture>
                            <source media="(max-width: 1100px)" srcSet="https://resource.ewe.rs/media/EWEoucher/DONJA%20KARTICA-mob.png" />
                            <img src="https://resource.ewe.rs/media/EWEoucher/DONJA%20KARTICA.png" alt="EWEoucher" className={`img-fluid ${styles['footer-card-image']}`} />
                        </picture>
                        <h3 className={`${styles['second-section-title']} ${styles['footer-title']} ${styles['footer-card-title']}`}>{t('staJos')}<span>{t('ewe')}oucher</span>-u?</h3>
                    </div>
                    <div className={styles['footer-text-holder']}>
                        <div style={{ textAlign: 'left' }}>
                            <p className={`${styles['second-section-text']} ${styles['second-section-text-flex']}`}>
                                <div className={styles['res-circle']}></div>
                                {t('vrednostaPopusta')}{t('ewe')}{t('pojedinacnProm')}{t('ewe')}{t('oucher?')}.{t('trajanjePromocije')}
                            </p>
                            <p className={`${styles['second-section-text']} ${styles['second-section-text-flex']}`}>
                                <div className={styles['res-circle']}></div>
                                {t('jeidnstveniVaucer')}                        </p>
                            <p className={`${styles['second-section-text']} ${styles['second-section-text-flex']}`}>
                                <div className={styles['res-circle']}></div>
                                {t('30DanaRok')}                        </p>
                            <p className={`${styles['second-section-text']} ${styles['second-section-text-flex']}`}>
                                <div className={styles['res-circle']}></div>
                                {t('jedanVaucer')}                        </p>
                        </div>
                    </div>
                </div>
                <div className={styles['footer-button']}>{t('USKORO')}</div>
            </div>
        </div >
    </>
    )
}

export default EweoucherLanding
